/* eslint-disable react/prop-types */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import './Input.css'

import React, { useState } from 'react'

import { Button } from '../../../../../ui/Button'
import Label from '../../Label'


export default function FileInput({
  accept,
  label,
  onChange,
  'data-test-id': dataTestId
}) {
  const [ files, setFiles ] = useState([])
  return (
    <div className="form-group">
      {label && files.length ? (
        <div className="form-group">
          <>
            <Label>
              {label}
            </Label>
            <div className="form-control">
              <div id="inlineloaded"></div>
              {files[0] &&
                <a href={files[0].name} alt="" target="_blank" rel="noopener noreferrer">{files[0].name}</a>}
            </div>
          </>
        </div>
      ) : null}
      <div className="uploadwrap">
        {files.length ? (
          <Button type="button" className="btn btn-primary" onClick={() => {
            setFiles([])
            onChange(null)
          }}>Remove file</Button>
        ) : (
          <>
            <input
              type="file"
              accept={accept}
              className="form-control"
              onChange={e => {
                setFiles(e.target.files)
                onChange(e.target.files)
              }}
              data-test-id={dataTestId}
            />
            <Button type="button" className="btn btn-primary">Upload a file</Button>
          </>
        )}
      </div>
    </div>
  )
}
